module.exports = __webpack_public_path__ + "static/media/sallev4.49ece2c1.jpg";